
<fv-drawing-number-list [rtaNum]="draftId"></fv-drawing-number-list>
<form [formGroup]="appRouterData">
<div class="row">
    <div class="col-md-12" *ngIf="(sapInitial$|async) as sapInitial">
        <div class="row">
            <div class="col-sm-12">
                <kendo-card style="width: 100%">
                    <kendo-card-header class="k-hstack">
                        Bit Head
                    </kendo-card-header>
                    <kendo-card-body>
                        <div class="row" *ngIf="sapInitial.BodyType !== 'MATRIX'">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-6">Steel Relief:</div>
                                <div class="col-sm-4">
                                    <kendo-checkbox  formControlName="SteelRelief" #SteelRelief></kendo-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="sapInitial.BodyType !== 'MATRIX'">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-12">Hardfacing Detail:</div>
                                <div class="col-sm-12">
                                    <kendo-dropdownlist formControlName="BitHead_HardFacingDetail" #BitHead_HardFacingDetail
                                        [data]="HardFacingDetailLookUp"
                                        valueField="DrawingName"
                                        textField="DrawingName"
                                        [valuePrimitive]="true">
                                        <ng-template kendoDropDownListItemTemplate let-dataItem>
                                            <span>{{ dataItem.DrawingName }}</span> <i>{{ dataItem?.Description }}</i>
                                        </ng-template>
                                        <ng-template kendoDropDownListValueTemplate  let-dataItem>
                                            <span>{{ dataItem?.DrawingName }}</span> <span *ngIf="dataItem?.Description"><i>-{{ dataItem?.Description }}</i></span>
                                        </ng-template>
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="sapInitial.BodyType !== 'MATRIX'">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-12">Masking Detail:</div>
                                <div class="col-sm-12">
                                    <kendo-dropdownlist formControlName="BitHead_MaskingDetail" #BitHead_MaskingDetail
                                        [data]="BomMaskingDetail"
                                        valueField="DrawingName"
                                        textField="DrawingName"
                                        [valuePrimitive]="true">
                                        <ng-template kendoDropDownListItemTemplate let-dataItem>
                                            <span>{{ dataItem.DrawingName }}</span> <i>{{ dataItem?.Description }}</i>
                                        </ng-template>
                                        <ng-template kendoDropDownListValueTemplate  let-dataItem>
                                            <span>{{ dataItem?.DrawingName }}</span> <span *ngIf="dataItem?.Description"><i>-{{ dataItem?.Description }}</i></span>
                                        </ng-template>
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="sapInitial.BodyType !== 'MATRIX'">
                            <div class="form-group col-sm-12" >
                                <div class="col-sm-12">{{!sapInitial.OnePiece ? 'Angle Box Detail:' : 'Sacrifical Box Detail:'}}</div>
                                <div class="col-sm-12">
                                    <kendo-dropdownlist formControlName="BitHead_SacrificalBoxName" #BitHead_SacrificalBoxName
                                        
                                        [data]="AngleBoxDetail">
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-6">Ring Gauge:</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-12">
                                    <kendo-multiselect formControlName="BitHeadRingGauge" #BitHeadRingGauge
                                        [data]="GaugeByBitSize" textField="DrawingNumber" valueField="ID"
                                        [valuePrimitive]="true">
                                    </kendo-multiselect>
                                </div>
                            </div>
                        </div>
                    </kendo-card-body>
                </kendo-card>
                <kendo-card *ngIf="sapInitial.Sleeve" style="width: 100%">
                    <kendo-card-header class="k-hstack">
                        Sleeve
                    </kendo-card-header>
                    <kendo-card-body>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-6">Hardfacing Detail:</div>
                                <div class="col-sm-6">
                                    <kendo-dropdownlist formControlName="Sleeve_HardFacingDetail" #Sleeve_HardFacingDetail
                                        [data]="HardFacingSleeveLookup">
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-6">Masking Detail:</div>
                                <div class="col-sm-6">
                                    <kendo-dropdownlist formControlName="Sleeve_MaskingDetail" #Sleeve_MaskingDetail
                                        [data]="BomMaskingSleeve">
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <div class="col-sm-6">Sacrifical:</div>
                                <div class="col-sm-6">
                                    <kendo-dropdownlist formControlName="Sleeve_SacrificalBox" #Sleeve_SacrificalBox
                                        [data]="BomSacrificalSleeve">
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                        </div>
                    </kendo-card-body>
                </kendo-card>
            </div>
        </div>
    </div>
</div>
</form>
